//
// Module for the Retirement Setup wizard's Eligibility step's Detail partial view
//
rs.module("participant/benefit/setup/retirement/wizard/eligibilitystepdetail",

    ["controls/components/event-banner",
     "common/visibility"],

    function (eventBanner, visibility) {

        // Initialize the module
        function initialize(jsSelectors, defaultValues, codeValues, payOptionMethodDictionary, suppPayOptionMethodDictionary, variablePayOptionKeys) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var payOptionSelect = stepContainer.js(jsSelectors.payOptionSelect);
            var suppPayOptionSelect = stepContainer.js(jsSelectors.suppPayOptionSelect);
            var payOptionChildContainer = stepContainer.js(jsSelectors.payOptionChildContainer);
            var payOptionPercentInput = stepContainer.js(jsSelectors.payOptionPercentInput);
            var payOptionYearsInput = stepContainer.js(jsSelectors.payOptionYearsInput);
            var payOptionPaymentsInput = stepContainer.js(jsSelectors.payOptionPaymentsInput);
            var payOptionTerminationDateInput = stepContainer.js(jsSelectors.payOptionTerminationDateInput);
            var payOptionTerminationDateHidden = stepContainer.js(jsSelectors.payOptionTerminationDateHidden);
            var beneficiariesContainer = stepContainer.js(jsSelectors.beneficiariesContainer);

            // Hookup payOptionSelect change event
            payOptionSelect.change(payOptionChange);
            suppPayOptionSelect.change(payOptionChange);

            // Hookup payOptionYearsInput and payOptionPaymentsInput change events
            payOptionYearsInput.on('input', payOptionYearsChange);
            payOptionPaymentsInput.on('input', payOptionPaymentsChange);

            // Pay Option change event
            function payOptionChange() {

                // Get selected Pay Option Key
                var selectedPayOptionKey = payOptionSelect.val();
                var selectedSuppPayOptionKey = suppPayOptionSelect.val();

                // Get corresponding selected Pay Option Method
                var selectedPayOptionMethod = payOptionMethodDictionary[selectedPayOptionKey];
                var selectedSuppPayOptionMethod = suppPayOptionMethodDictionary[selectedSuppPayOptionKey];

                // Get default termination date in ISO string
                var defaultTerminationDate = defaultValues.terminationDate ? new Date(defaultValues.terminationDate).toISODateString() : null;

                // clear any messages in the message banner
                eventBanner.removeAllMessages();

                // set visibility of pay option container and enabling/disabling of child fields
                if (selectedPayOptionKey && variablePayOptionKeys.includes(selectedPayOptionKey)) {

                    visibility.setVisible(payOptionChildContainer, true);

                    if (selectedPayOptionMethod == codeValues.contingentJandS ||
                        selectedPayOptionMethod == codeValues.trueJAndS ||
                        selectedPayOptionMethod == codeValues.jAndSPopup) {

                        payOptionPercentInput.prop("disabled", false);
                        payOptionYearsInput.prop("disabled", true).val("").clearErrors();
                        payOptionPaymentsInput.prop("disabled", true).val("").clearErrors();
                        payOptionTerminationDateInput.prop("disabled", true).val(defaultTerminationDate).clearErrors();
                        payOptionTerminationDateHidden.val(defaultTerminationDate);
                    }
                    else if (selectedPayOptionMethod == codeValues.certainAndLife) {
                        payOptionPercentInput.prop("disabled", true).val("").clearErrors();
                        payOptionYearsInput.prop("disabled", false);
                        payOptionPaymentsInput.prop("disabled", false);
                        payOptionTerminationDateInput.prop("disabled", true).val(defaultTerminationDate).clearErrors();
                        payOptionTerminationDateHidden.val(defaultTerminationDate);
                    }
                    else if (selectedPayOptionMethod == codeValues.term) {
                        payOptionPercentInput.prop("disabled", true).val("").clearErrors();
                        payOptionYearsInput.prop("disabled", false);
                        payOptionPaymentsInput.prop("disabled", false);
                        payOptionTerminationDateInput.prop("disabled", false);
                        payOptionTerminationDateHidden.val(defaultTerminationDate);
                    }
                    else {
                        payOptionPercentInput.prop("disabled", true).val("").clearErrors();
                        payOptionYearsInput.prop("disabled", true).val("").clearErrors();
                        payOptionPaymentsInput.prop("disabled", true).val("").clearErrors();
                        payOptionTerminationDateInput.prop("disabled", true).val(defaultTerminationDate).clearErrors();
                        payOptionTerminationDateHidden.val(defaultTerminationDate);
                    }
                }
                else {
                    visibility.setVisible(payOptionChildContainer, false);
                    payOptionPercentInput.prop("disabled", true).val("").clearErrors();
                    payOptionYearsInput.prop("disabled", true).val("").clearErrors();
                    payOptionPaymentsInput.prop("disabled", true).val("").clearErrors();
                    payOptionTerminationDateInput.prop("disabled", true).val(defaultTerminationDate).clearErrors();
                    payOptionTerminationDateHidden.val(defaultTerminationDate);
                }

                // set visibility of beneficiaries container
                var showBeneficiaries =
                    (selectedPayOptionKey && selectedPayOptionMethod != codeValues.singleLife) ||
                    (selectedSuppPayOptionKey && selectedSuppPayOptionMethod != codeValues.singleLife);

                visibility.setVisible(beneficiariesContainer, showBeneficiaries);
            }

            // On payOptionYearsInput change
            function payOptionYearsChange() {

                var yearsEntered = payOptionYearsInput.val() !== '';

                // If a value for years is entered, disable and clear the payments input
                payOptionPaymentsInput.prop('disabled', yearsEntered);
                if (yearsEntered) {
                    payOptionPaymentsInput.val("").clearErrors();
                }
            }

            // On payOptionPaymentsInput change
            function payOptionPaymentsChange() {

                var paymentsEntered = payOptionPaymentsInput.val() !== '';

                // If a value for payments is entered, disable and clear the years input
                payOptionYearsInput.prop('disabled', paymentsEntered);
                if (paymentsEntered) {
                    payOptionYearsInput.val("").clearErrors();
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);